import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    useEffect(() => {
        const checkAuth = () => {
            const adminToken = localStorage.getItem('adminToken');
            setIsAuthenticated(!!adminToken);
        };
        checkAuth();
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'adminToken') {
                checkAuth();
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);
    if (isAuthenticated === null) {
        return <div>Проверка авторизации...</div>;
    }
    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }
    return <>{children}</>;
};

export default ProtectedRoute;